module.exports = {
          srcSet: __webpack_public_path__ + "2b3b1504206693a6ca910ebdcb546b0a-451.png"+" 451w",
          images:[ {path: __webpack_public_path__ + "2b3b1504206693a6ca910ebdcb546b0a-451.png",width: 451,height: 725}],
          src: __webpack_public_path__ + "2b3b1504206693a6ca910ebdcb546b0a-451.png",
          toString:function(){return __webpack_public_path__ + "2b3b1504206693a6ca910ebdcb546b0a-451.png"},
          
          width: 451,
          height: 725
        }